export interface GetMasterPlanLocationLookupRequest {
    searchParam? : string;
    pageSize?: number;
    pageNumber?: number;
    planContainerId?: string;
    locationGroupId?: string;
    locationType? : string;
  }
  